import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { DropdownMenu } from '@uhg-abyss/web/ui/DropdownMenu';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Text } from '@uhg-abyss/web/ui/Text';

export const CTAContent = styled('button', {
  display: 'flex',
  cursor: 'pointer',
  justifyContent: 'center',
  alignItems: 'center',
  width: '25%',
});

export const CTAText = styled(Text, {
  color: '$milesTextColor',
  fontSize: '$extraSmallText !important',
  fontWeight: 590,
});

export const ProviderInfoCard = styled(Flex, {
  minHeight: '365px',
  gap: '8px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.12)',
  border: ' 1px solid #E5E5E6',
  padding: '16px 8px',
  borderRadius: '8px',
  flexWrap: 'nowrap',
  '.abyss-flex-root': {
    textAlign: 'center',
  },
  '@media (min-width: 745px)': {
    width: '282px',
  },
  '@media (max-width: 744px)': {
    display: 'flex',
    width: '90%',
    marginBottom: '20px',
  },
});

export const ResponsiveText = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '14px',
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    overflow: 'hidden',
    maxWidth: '175px',
    '@media (max-width: 464px)': {
      fontSize: '$extraSmallText',
      '-webkit-line-clamp': '1',
      maxWidth: '140px',
      lineHeight: '16px',
    },
  },
  wordBreak: 'break-word',
  variants: {
    ancillarySpeciality: {
      true: {
        '&.abyss-text-root': {
          '-webkit-line-clamp': '1',
          textAlign: 'left',
          maxWidth: '230px',
          display: 'block',
          '@media (max-width: 464px)': {
            maxWidth: '200px',
          },
        },
      },
    },
  },
});

export const CareTeamDropDown = styled(DropdownMenu, {
  '.abyss-dropdown-menu-root': {
    backgroundColor: 'transparent',
    color: 'inherit',
    border: 'none',
    fontWeight: 'normal',
    padding: '0',
    boxShadow: 'none',
    fontSize: '10px',
    '@media (max-width: 464px)': {
      fontSize: '$extraSmallText',
      '-webkit-line-clamp': '1',
    },
  },
});

export const badgeStyles = {
  '.abyss-badge-root': {
    border: '0.1px solid #000 !important',
    borderRadius: '2px',
    padding: '2px 4px',
  },
  '.abyss-badge-content': {
    fontSize: '12px',
    '@media (max-width: 464px)': {
      fontSize: '$extraSmallText',
      '-webkit-line-clamp': '1',
    },
  },
};

export const CTAContainer = styled(Flex, {
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'space-around',
  display: 'flex',
  width: '100%',
});

export const CareTeamDropDownWrapper = styled('div', {
  position: 'relative',
  display: 'inline-block',
});

export const Avatar = styled(Flex, {
  backgroundColor: '$snackCardAvatarBackgroundColor',
  width: '128px',
  height: '128px',
  borderRadius: '50%',
  border: '1px solid #F3F3F3',
  overflow: 'hidden',
  '& img': {
    width: '100%',
    height: '100%',
    objectPosition: 'inherit',
    objectFit: 'cover',
  },
});

export const PhoneTag = styled('a', {
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  '&:hover,&:active': {
    textDecoration: 'none',
  },
  marginTop: '0.5rem',
});

export const ModalTitle = styled(Text, {
  '&.abyss-text-root': {
    width: '100%',
    fontSize: '16px',
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    overflow: 'hidden',
    lineHeight: '20px',
    '@media (max-width: 464px)': {
      fontSize: '$extraSmallText',
      '-webkit-line-clamp': '1',
      width: '150px',
      lineHeight: '16px',
    },
  },
});

export const CallContainer = styled('div', {
  marginBottom: '1rem',
  borderColor: '#ccc',
  borderStyle: 'solid',
  borderRadius: '8px',
  width: '55%',
  '@media (max-width: 464px)': {
    width: '70%',
  },
  borderWidth: '1px',
  padding: '0.8rem',
});

export const ScheduleContainer = styled(Flex, {
  padding: '10px',
  borderRadius: '8px',
  variants: {
    isSelected: {
      true: {
        border: '2px solid #196ECF',
      },
      false: {
        border: '0px',
      },
    },
  },
});
export const CancelButton = styled(Button, {
  color: '$notificationColor',
  marginRight: '8px',
});

export const ScheduleButton = styled(Button, {
  '&:hover': {
    background: '$notificationInteractiveColor',
  },
});

export const ProviderCardContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignContent: 'center',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  height: '100%',
  variants: {
    isNetworkStatus: {
      true: {
        cursor: 'pointer',
      },
      false: {
        cursor: 'default',
      },
    },
  },
});

export const SnackContainer = styled('div', {
  display: 'flex',
  '@media (max-width: 744px)': {
    height: '100%',
    width: '100%',
    justifyContent: 'center',
  },
});

export const phoneTextStyle = {
  padding: '0 4px !important',
  fontSize: '14px !important',
  '@media (max-width: 464px)': {
    fontSize: '$extraSmallText !important',
    fontWeight: '700',
  },
};

export const LearnMoreDrawer = styled('div', {
  color: 'black',
  padding: '16px',
  boxSizing: 'border-box',
  overflow: 'auto',
  lineHeight: '20px',
  fontSize: '16px',
  fontFamily: '$primary',
});

export const LearMoreLink = styled('a', {
  color: '#196ECF',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: '600',
  lineHeight: '18px',
});

export const NetworkStatusWithPlanName = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  justifyContent: 'center',
  alignContent: 'center',
  padding: '2px 4px',
});

export const HiddenSpecialityDiv = styled('div', {
  width: '16px',
  minHeight: '16px',
  visibility: 'hidden',
});

export const HiddenCtaDiv = styled('div', {
  width: '40px',
  minHeight: '10px',
  visibility: 'hidden',
});
